import React from "react";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
export var CartItemPreview = function CartItemPreview(_ref) {
  var title = _ref.title,
      modNames = _ref.modNames,
      cost = _ref.cost,
      imgUrl = _ref.imgUrl,
      children = _ref.children,
      showCost = _ref.showCost,
      variantOptions = _ref.variantOptions,
      addOn = _ref.addOn;
  var costTweaked = cost;

  try {
    costTweaked = parseFloat(cost).toFixed(2);
  } catch (_unused) {
    console.log("previewItem parse issue");
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "cb-cart__item"
  }, /*#__PURE__*/React.createElement("img", {
    src: imgUrl
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-card__item-contents"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-card__item-contents--cart"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    className: "cb-cart__item__title",
    field: {
      value: title
    }
  }), /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    className: "cb-cart__item__desc",
    field: {
      value: modNames.join(", ")
    }
  }), /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    className: "cb-cart__item__desc",
    field: {
      value: variantOptions
    }
  }), !!(addOn === null || addOn === void 0 ? void 0 : addOn.name) && /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    className: "cb-cart__item__copy--sm add-on",
    field: {
      value: "<strong>$".concat(addOn.cost, " Take Home Meal</strong><br />").concat(addOn.name, " (+$").concat(parseFloat(addOn.cost).toFixed(2), ")")
    }
  })), !showCost && /*#__PURE__*/React.createElement("p", {
    className: "cb-cart__item__copy cb-cart__cost"
  }, "$", costTweaked)), children));
};